// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '93f83e07248a8cd6e1c11316eb7de08d00a0cbba';
export const BUILD_NUMBER = '237';
export const BUILD_TIMESTAMP = '2026-09-15T07:45:12.753Z';
